import { render, staticRenderFns } from "./resourceUsageStatistics.vue?vue&type=template&id=3099e51e&"
import script from "./resourceUsageStatistics.vue?vue&type=script&lang=js&"
export * from "./resourceUsageStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports